import { useState } from "react";
import MDButton from "./MDButton";

export const DownloadButton = ({ donation }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      // Call YOUR Proxy

      const data = {
        orderId: donation.provider_order_id || donation.id,
        receiptNumber: donation.provider_order_id || donation.id,
        donorEmail: donation.email || "",
        donorPhone: donation.phone || "",
        amount: donation.total_amount_original, // USD
        amountTRY: donation.PurchAmount, // Realistic TRY conversion (32.5 TRY/USD)
        currency: donation.original_currency,
        language: donation.lang || "ar",
        isAnonymous: false,
        donationDate: new Date(donation.TransactionDate).toISOString(), // UTC
        donorName: donation.user || "فاعل خير ",
        items: donation.donation_items.map((item) => ({
          title: item.project || "تبرع عام",
          subtitle: item.quantity
            ? `العدد: ${item.quantity}, باسم: ${
                item.recipient_name || "غير محدد"
              }`
            : item.recurring_frequency
            ? `تكرار: ${item.recurring_frequency}, لمدة: ${item.recurring_duration} شهر`
            : "",
          amount: item.cost,
          currency: item.original_currency || "",
        })),
      };
      console.log(data);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}api/receipt`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            donation: data,
            language: "ar",
          }),
        },
      );

      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();

      // Trigger browser download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `receipt-${donation.provider_order_id || donation.id}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error(err);
      alert("Failed to download receipt");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDButton color="info" onClick={handleDownload} disabled={loading}>
      {loading ? "جاري التحضير..." : "تحميل PDF"}
    </MDButton>
  );
};
